import { SB } from '@play-co/replicant';

export const entrySchema = {
  entry: SB.map(
    SB.object({
      /**
       * Timestamps of entries for each platform
       */
      timestamp: SB.number().default(0),
      /**
       * Timestamps of previous entries for each platform
       */
      previousTimestamp: SB.number().default(0),
    }),
  ).optional(),
};
